import React, { useState, useCallback } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  cursor: "pointer",
};

const imageWrapperStyle = {
  position: "relative",
  maxWidth: "95vw",
  maxHeight: "95vh",
  cursor: "default",
};

const fullscreenImageStyle = {
  maxWidth: "100%",
  maxHeight: "95vh",
  objectFit: "contain",
  display: "block",
};

const closeButtonStyle = {
  position: "absolute",
  top: "8px",
  right: "8px",
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  border: "none",
  borderRadius: "4px",
  color: "#fff",
  fontSize: "24px",
  lineHeight: 1,
  cursor: "pointer",
  padding: 0,
};

const thumbnailStyle = {
  width: "100%",
  maxHeight: "200px",
  objectFit: "contain",
  cursor: "pointer",
  display: "block",
};

export const DrawerSnapshoot = ({ thumbnailUrl, snapshotUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openFullscreen = useCallback(() => {
    if (snapshotUrl) setIsOpen(true);
  }, [snapshotUrl]);

  const closeFullscreen = useCallback((e) => {
    e.stopPropagation();
    setIsOpen(false);
  }, []);

  const stopPropagation = useCallback((e) => {
    e.stopPropagation();
  }, []);

  if (!snapshotUrl) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: '8px' }}>
      <img
        src={thumbnailUrl || snapshotUrl}
        alt="Snapshot"
        style={thumbnailStyle}
        onClick={openFullscreen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openFullscreen();
          }
        }}
      />
      {isOpen &&
        createPortal(
          <div
            style={overlayStyle}
            onClick={closeFullscreen}
            role="dialog"
            aria-modal="true"
          >
            <div
              style={imageWrapperStyle}
              onClick={stopPropagation}
            >
              <button
                type="button"
                style={closeButtonStyle}
                onClick={closeFullscreen}
                aria-label="Cerrar"
              >
                ×
              </button>
              <img
                src={snapshotUrl}
                style={fullscreenImageStyle}
              />
            </div>
          </div>,
          document.body
        )}
    </Box>
  );
};

